export const appendQueryParam = (path, key, value) => {
  if (!path) return path
  if (value === undefined || value === null || value === "") return path

  const [pathPart, hashPart = ""] = path.split("#")
  const [base, queryPart = ""] = pathPart.split("?")
  const sp = new URLSearchParams(queryPart)
  sp.set(key, String(value))
  const query = sp.toString()
  const result = query ? `${base}?${query}` : base
  return hashPart ? `${result}#${hashPart}` : result
}
